<template>
  <div v-if="cart !== null">
    <div class="gap-y-6 grid">
      <div class="gap-y-1 flex flex-col">
        <div
          v-for="code in appliedDiscountCodes"
          :key="code"
          class="bg-br-green-light fluid-xs leading-tightest py-3 font-medium text-center text-black"
        >
          <TagIcon class="inline-block h-3 mr-1 -mt-px" />
          <span>{{ $t('cart.appliedDiscountHint') }}</span>
          <span v-if="showDiscountCode(code)" class="-ml-px before:content-[':'] before:mr-1">{{ code }}</span>
        </div>
      </div>
      <div>
        <div v-if="hasDiscountApplied" class="fluid-base leading-relaxed flex justify-between font-normal">
          <div>{{ $t('cart.discountTotal') }}</div>
          <div v-if="discountValue" class="text-br-green">
            <span class="mr-1">-</span
            >{{
              $n(parseFloat(discountValue.amount), {
                style: 'currency',
                currency: discountValue.currencyCode,
              })
            }}
          </div>
        </div>

        <div class="fluid-base leading-relaxed flex justify-between font-normal">
          <div>{{ $t('cart.subtotal') }}</div>

          <div v-if="isProcessing" class="text-blackly">
            <SpinnerIcon class="h-4 animate-spin" />
          </div>
          <div v-else class="flex flex-col items-end">
            <div>
              {{
                $n(parseFloat(cart.cost.totalAmount.amount), {
                  style: 'currency',
                  currency: cart.cost.totalAmount.currencyCode,
                })
              }}
            </div>
            <s v-if="hasDiscountApplied" class="text-gray-light fluid-xs leading-tightest font-light">
              {{
                $n(parseFloat(totalAmountWithoutDiscount), {
                  style: 'currency',
                  currency: cart.cost.subtotalAmount.currencyCode,
                })
              }}
            </s>
          </div>
        </div>
        <div class="fluid-xs leading-tightest text-gray-light">{{ $t('cart.vatHint') }}</div>
      </div>

      <DeliveryDetails />

      <template v-if="!hasDiscountApplied">
        <hr />
        <div class="fluid-xs leading-tightest">{{ $t('cart.voucherHint') }}</div>
      </template>
      <div>
        <div class="fluid-xs leading-tightest mb-2 font-medium">{{ $t('navigation.paymentMethods') }}</div>
        <PaymentMethodsIcons v-if="paymentMethods" :methods="paymentMethods" />
      </div>
      <CartNotification />
    </div>
  </div>
</template>

<script>
import CartNotification from '@/components/cart/CartNotification';
import PaymentMethodsIcons from '@/components/common/PaymentMethodsIcons';
import SpinnerIcon from '@/components/icons/SpinnerIcon.vue';
import TagIcon from '@/components/icons/TagIcon';
import DeliveryDetails from '@/components/cart/DeliveryDetails';
import { useCartStore } from '@/stores/cart';
import { useCartSettingsStore } from '@/stores/cart-settings';
import { storeToRefs } from 'pinia';

export default defineNuxtComponent({
  components: {
    DeliveryDetails,
    PaymentMethodsIcons,
    CartNotification,
    TagIcon,
    SpinnerIcon,
  },

  setup() {
    const cartStore = useCartStore();
    const cartSettingsStore = useCartSettingsStore();

    const { hasDiscountApplied, discountValue, appliedDiscountCodes, isProcessing, cart } = storeToRefs(cartStore);
    const { paymentMethods } = storeToRefs(cartSettingsStore);

    const close = () => cartStore.close();

    return {
      hasDiscountApplied,
      discountValue,
      appliedDiscountCodes,
      isProcessing,
      cart,
      paymentMethods,
      close,
    };
  },

  computed: {
    priceWithGiftCard() {
      const price = +this.cart.cost.subtotalAmount.amount;
      return price > 0 ? price : 0;
    },

    totalAmountWithoutDiscount() {
      return parseFloat(this.cart.cost.totalAmount.amount) + this.discountValue.amount;
    },
  },
  methods: {
    showDiscountCode(code) {
      if (!code) {
        return false;
      }

      if (
        code.toLowerCase().startsWith('xsell-deal') ||
        code.toLowerCase().startsWith('upsell-deal') ||
        code.toLowerCase().startsWith('test')
      ) {
        return false;
      }

      return code;
    },
  },
});
</script>
